module.exports = __webpack_public_path__ + "img/case20.deb6e66d.png";